import { logStore } from "../stores/logStore";
export function ErrorHandler(event) {
    const { logger } = logStore.getState();
    ;
    return logger(event);
}
